module.exports = __webpack_public_path__ + "static/logo-25f06e9441b2fe2cf2a84ec638d0cd1a.png";